import React, { memo } from 'react';
import { SUPPORTED_COUNTRIES } from '@honeybook/i18n';
import type { SupportedCountry } from '@honeybook/i18n';
import HBInputField, { HBInputFieldProps } from '../HBInputField/HBInputField';
import { getAddressFieldConfig } from './HBAddress.utils';
import { useHBTranslation } from '../HBUIProvider/HBUIProvider';

export type HBAddressCityFieldProps = Omit<
    HBInputFieldProps,
    'label' | 'ref'
> & {
    /** The currently selected country code. For AU, the label changes to "Suburb". */
    country: string;
    /** Override the auto-derived label (City or Suburb for AU). */
    label?: string;
    /** Identifier segment appended to the component name to build data-testid. */
    testIdName?: string;
    /** Explicit test ID string; sets data-testid directly. */
    testId?: string;
};

const HBAddressCityField = ({
    country,
    label,
    ...props
}: HBAddressCityFieldProps) => {
    const t = useHBTranslation();
    const isSupportedCountry = (SUPPORTED_COUNTRIES as string[]).includes(
        country
    );
    const config = isSupportedCountry
        ? getAddressFieldConfig(country as SupportedCountry)
        : null;

    const derivedLabel =
        label ?? t(config ? config.cityKey : 'hbAddress.city.city');

    return (
        <HBInputField
            placeholder={derivedLabel}
            {...props}
            label={derivedLabel}
        />
    );
};

export default memo(HBAddressCityField);
